import React from 'react';
import PropTypes from 'prop-types';
import { CloseSmallIcon } from 'DesignSystem/Icons';

const TooltipCloseButton = ({ onClick }) => (
  <CloseSmallIcon
    className="ds-tooltip-close-btn"
    onClick={onClick}
  />
);

TooltipCloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default TooltipCloseButton;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Tooltips/components/TooltipCloseButton.jsx